export const inputRules = {
  preorderPeriod: {
    required: {
      value: true,
      message: {
        key: 'The shipping delay days cannot be left blank or set to fewer than 30.',
        options: {
          ns: 'main',
        },
      },
    },
    pattern: {
      value: /^\d+$/,
      message: {
        key: 'Please enter numbers only',
        options: {
          ns: 'main',
        },
      },
    },
    min: {
      value: 30,
      message: {
        key: 'The shipping delay days cannot be left blank or set to fewer than 30.',
        options: {
          ns: 'main',
        },
      },
    },
    max: {
      value: 364,
      message: {
        key: 'max',
        options: {
          ns: 'fieldValidation',
          value: 364,
        },
      },
    },
  },
  regionAndLocaleSets: {
    required: {
      value: true,
      message: {
        key: 'required',
        options: {
          ns: 'fieldValidation',
        },
      },
    },
  },
};
